var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewCompensation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#F5FBE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 37.2a1.04 1.04 0 01-1.1-1.1v-3.3h-5.5a1.1 1.1 0 010-2.2h5.5v-5.5h-1.65a4.95 4.95 0 110-9.9h1.65v-3.3a1.04 1.04 0 011.1-1.1 1.04 1.04 0 011.1 1.1v3.3H30a1.04 1.04 0 011.1 1.1 1.04 1.04 0 01-1.1 1.1h-4.4v5.5h1.65a4.95 4.95 0 110 9.9H25.6v3.3a1.04 1.04 0 01-1.1 1.1zm1.1-12.1v5.5h1.65a2.75 2.75 0 100-5.5H25.6zm-3.85-7.7a2.75 2.75 0 100 5.5h1.65v-5.5h-1.65z",
    fill: "#6FCF97"
  })));
}
export default SvgReviewCompensation;